import React from "react";
import LegalMarkdownPage from "./LegalMarkdownPage";

import refundEnglish from "../docs/refund-policy/refund.en.md";
import refundSpanish from "../docs/refund-policy/refund.es.md";
import refundItalian from "../docs/refund-policy/refund.it.md";
import refundFrench from "../docs/refund-policy/refund.fr.md";
import refundArabic from "../docs/refund-policy/refund.ar.md";

import "../styles/LegalPages.css";

const refundDocuments = {
  en: refundEnglish,
  fr: refundFrench,
  ar: refundArabic,
  es: refundEnglish, // no Spanish market yet, English reference version
  it: refundEnglish, // no Italian market yet, English reference version
};

const RefundPolicy = () => {
  return (
    <LegalMarkdownPage
      documents={refundDocuments}
      containerClassName="legal-page-container"
      headingClassName="legal-page-heading"
      errorMessage="The Refund Policy could not be loaded."
    />
  );
};

export default RefundPolicy;
